import React, { FC, useState } from 'react';
import styles from './StaticProductDetails.module.scss';
import FalconDescription from '../FalconDescription/FalconDescription';
import FalconAccordionList from '../FalconAccordionList';
import { FALCONDESCRIPTION, FALCONDESCRIPTIONLIST, SPACER } from '../../utils/constants';
import Row from '../ResponsiveRow/row';
import Spacer from '../Spacer/Spacer';
import { StaticProductDetailsSchema } from './StaticProductDatatypes';
import DynamicPriceSection from './DynamicPriceSection';
import { replacePlaceholder } from '../../utils/utils';
import CheckoutButton from './CheckoutButton';
import StaticProductDetailsModal from './StaticProductDetailsModal';

const StaticProductDetails: FC<StaticProductDetailsSchema> = ({
  content,
  showProductDetail,
  setShowProductDetail,
  constants,
  showPrice,
  isMobileFlow,
  createCartCall,
  storyContent,
  isAvailable,
  address,
  flexUpgradeFreePopup
}) => {
  const [modalState, setModalState] = useState(true);
  let falconBody: any = [],
    backBtn = '';
  content &&
    content.length > 0 &&
    content?.map((e: any) => {
      falconBody = e?.modalBody;
      backBtn = e?.backButton;
    });

  const handleClick = () => {
    setModalState(!modalState);
    setShowProductDetail(!showProductDetail);
  };

  return (
    <>
      <StaticProductDetailsModal
        modalState={modalState}
        handler={handleClick}
        showFooter={false}
        height={'100%'}
        backButton={backBtn}
      >
        <>
          {falconBody?.map((ele: any, index: number) => (
            <Row>
              <>
                {ele?.component === FALCONDESCRIPTION && (
                  <FalconDescription content={ele} key={index} />
                )}
                {ele?.component === SPACER && <Spacer content={ele} />}
                {ele?.component === FALCONDESCRIPTIONLIST && <FalconAccordionList content={ele} />}
              </>
            </Row>
          ))}
          <div className={`footer-main ${styles['check-footer']} `}>
            <span className={`${styles['footer-linetablev3']}`}>
              <div>
                <DynamicPriceSection priceCollection={showPrice} constants={constants} />
                <div>
                  {showPrice?.contractDuration
                    ? replacePlaceholder(constants?.minContractDuration?.substring(1), [
                        showPrice?.contractDuration
                      ])
                    : constants?.noContractDuration}
                </div>
              </div>
              <div className={styles.cartbtn}>
                <CheckoutButton
                  isMobileFlow={isMobileFlow}
                  createCartCall={createCartCall}
                  constants={constants}
                  storyContent={storyContent}
                  showPrice={showPrice}
                  isAvailable={isAvailable}
                  address={address}
                  flexUpgradeFreePopup={flexUpgradeFreePopup}
                  content={content}
                />
              </div>
            </span>
          </div>
        </>
      </StaticProductDetailsModal>
    </>
  );
};
export default StaticProductDetails;
